import { apiService } from './apiService';
import { notifyNotificationsChanged } from './notificationService';

export const driverDefenseService = {
  mine: async () => {
    const response = await apiService.get('/driver-defenses/mine');
    if (response.success) notifyNotificationsChanged();
    return response;
  },
  pendingCount: async () => {
    const response: any = await apiService.get('/driver-defenses/mine?markViewed=false');
    return (response?.data || []).filter((item: any) => item.defense_status !== 'submitted').length;
  },
  requestCode: (violationIds: number[], defenseText: string) => apiService.post('/driver-defenses/request-code', { violationIds, defenseText }),
  verify: (violationIds: number[], code: string) => apiService.post('/driver-defenses/verify', { violationIds, code }),
};
